import { AudioPlayer } from 'app/components/AudioPlayer';
import { EditGreetingDialogVmbox } from 'app/components/EditGreetingDialogVmbox';
import { EditHoldMusicDialogUser } from 'app/components/EditHoldMusicDialogUser';
import { useFindInPage } from 'app/components/FindInPage';
import { GenericSettingsCardField } from 'app/components/GenericSettingsCardField';
import { useToggleReducer } from 'app/utilities';
import * as React from 'react';
import { Vmbox } from 'types/vmbox';

interface GreetingVmboxProps {
  vmbox: Vmbox;
  onComplete: () => void;
}

const GreetingVmbox = ({ vmbox, onComplete }: GreetingVmboxProps) => {
  const [showEditDialog, toggleShowEditDialog] = useToggleReducer(false);
  const { ref, HighlightPulse, highlightPulseProps } = useFindInPage({
    name: 'greeting',
    options: [
      {
        label: 'Greeting',
        value: 'greeting',
      },
    ],
    onChoose: 'matchAnyScrollToRef',
  });

  const handleOnComplete = () => {
    onComplete();
    toggleShowEditDialog();
  };

  return (
    // @ts-ignore
    <div ref={ref}>
      <HighlightPulse {...highlightPulseProps} />
      {showEditDialog ? (
        <EditGreetingDialogVmbox
          vmboxId={vmbox.id}
          mediaId={vmbox.doc.media.unavailable}
          onComplete={handleOnComplete}
          onCancel={toggleShowEditDialog}
        />
      ) : null}
      <GenericSettingsCardField
        title={'Greeting'}
        content={
          vmbox.doc.media.unavailable ? (
            <AudioPlayer mediaId={vmbox.doc.media.unavailable} />
          ) : undefined
        }
        editOnClick={toggleShowEditDialog}
        editLabel={
          vmbox.doc.media.unavailable ? 'Change Greeting' : 'Add Greeting'
        }
      />
    </div>
  );
};

export default GreetingVmbox;
